// A 402 already raises the billing modal, so call sites skip their own toast.
export const PAYMENT_REQUIRED_STATUS = 402;

// Thrown by limitAwareFetch, whose callers never see an axios response.
export class BillingLimitError extends Error {
  constructor() {
    super("Usage limit reached");
    this.name = "BillingLimitError";
  }
}

export function isBillingLimitError(error: unknown): boolean {
  if (error instanceof BillingLimitError) return true;
  return (
    (error as { response?: { status?: number } } | null)?.response?.status ===
    PAYMENT_REQUIRED_STATUS
  );
}

export type BillingLimitScope = "installation" | "organization" | "workspace";

// Mirrors the params of the backend PaymentRequiredError (noxus.errors).
export type BillingLimitParams = {
  is_internal_limit?: boolean;
  limit_id?: string | null;
  metric?: string | null;
  scope?: BillingLimitScope | null;
  group_id?: string | null;
  value?: number | null;
  reserved?: number | null;
  capacity?: number | null;
  payg_capacity?: number | null;
  filter?: Record<string, string>;
  next_reset_at?: string | null;
};

let openHandler: ((params: BillingLimitParams) => void) | null = null;

export function registerBillingLimitModal(
  openFn: (params: BillingLimitParams) => void
) {
  openHandler = openFn;
}

export function openBillingLimitModal(params: BillingLimitParams | undefined) {
  if (typeof window !== "undefined") openHandler?.(params ?? {});
}
